var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["contentful/render-modules.j2"] = require( "contentful/render-modules.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/contentful/content-accordion-module.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"headline")) {
output += "\n    <h2>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"headline"), env.opts.autoescape);
output += "</h2>\n";
;
}
output += "\n<div class=\"o-column o-extra-small--12 u-no-gutters\">\n    <div class=\"o-accordion c-content-accordion js-accordion\" role=\"tablist\" aria-multiselectable=\"true\">\n        <div class=\"o-accordion__tabset js-accordion-tabset ";
output += runtime.suppressValue((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"defaultState") != "OPEN"?"is-collapsed":""), env.opts.autoescape);
output += "\">\n\n            <div class=\"o-row\">\n                <div class=\"o-column o-extra-small--12\">\n                    <a href=\"#";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"sys")),"id"), env.opts.autoescape);
output += "\" id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"sys")),"id"), env.opts.autoescape);
output += "\" class=\"\n                    o-accordion__tab c-content-accordion__tab js-accordion-tab";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"headerAlignment")) {
output += "\n                        c-content-accordion__tab--";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"headerAlignment"), env.opts.autoescape);
output += "-align\n                    ";
;
}
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"headerBottomMargin")) {
output += "\n                        ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"headerBottomMargin"), env.opts.autoescape);
output += "\n                    ";
;
}
output += "\" aria-selected=\"true\" aria-controls=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"sys")),"id"), env.opts.autoescape);
output += "\" aria-expanded=\"true\" role=\"tab\" name=\"";
output += runtime.suppressValue(env.getFilter("lower").call(context, env.getFilter("replace").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"title")," ","-")), env.opts.autoescape);
output += "\" data-accordion-title=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"title"), env.opts.autoescape);
output += "\">\n                        ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"headline")) {
output += "\n                            <h3 class=\"o-accordion__label u-global-h5 c-content-accordion__heading\">\n                                ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"title"), env.opts.autoescape);
output += "\n                            </h3>\n                        ";
;
}
else {
output += "\n                            <h2 class=\"o-accordion__label u-global-h5 c-content-accordion__heading\">\n                                ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"title"), env.opts.autoescape);
output += "\n                            </h2>\n                        ";
;
}
output += "\n\n                        <span class=\"o-accordion__control c-content-accordion__control\" title=\"collapse\"></span>\n                    </a>\n                </div>\n            </div>\n\n            <div id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"sys")),"id"), env.opts.autoescape);
output += "\" class=\"o-accordion__panel c-content-accordion__panel js-accordion-panel\" aria-labelledby=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"sys")),"id"), env.opts.autoescape);
output += "\" aria-hidden=\"false\" role=\"tabpanel\">\n                ";
var t_1;
t_1 = runtime.contextOrFrameLookup(context, frame, "entry");
frame.set("data", t_1, true);
if(frame.topLevel) {
context.setVariable("data", t_1);
}
if(frame.topLevel) {
context.addExport("data", t_1);
}
output += "\n                ";
env.getTemplate("contentful/render-modules.j2", false, "core/templates/contentful/content-accordion-module.j2", null, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
t_2.render(context.getVariables(), frame, function(t_5,t_3) {
if(t_5) { cb(t_5); return; }
output += t_3
output += "\n            </div>\n\n        </div>\n    </div>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/contentful/content-accordion-module.j2"] , dependencies)